import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M24.051 42c8.735 0 16.552-7.575 16.552-16.535 0-4.916-2.37-9.831-5.915-12.555-1.112-.918-2.224-.79-2.869-.032-.709.79-.548 1.95.37 2.82 2.837 2.37 4.626 5.802 4.626 9.767a12.707 12.707 0 0 1-12.764 12.748c-7.075 0-12.78-5.69-12.78-12.764 0-6.012 4.11-11.008 9.67-12.378V15.2c0 1.305 1.305 1.692 2.272.95l5.141-3.916c.645-.5.645-1.434 0-1.917l-5.14-3.933c-.984-.757-2.273-.37-2.273.967v1.838C13.334 10.67 7.5 17.438 7.5 25.448 7.5 34.523 14.978 42 24.051 42Z"
    }
  )
);
var SvgReplayFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ReplayFilled_default = SvgReplayFilled;

export { ReplayFilled_default as default };
